import { useRequest } from '@rahtab/auth/lib/token-based-auth';
import { RequestCallTypes, RequestOptions } from '@rahtab/auth/lib/token-based-auth/useRequest';
import { useEffect, useState } from 'react';

export interface FetchResult<TData> {
  called: boolean;
  data?: TData;
  loading: boolean;
}

export type FetchFn = () => void;

export default function <TData = any>(
  callType: keyof RequestCallTypes,
  { skip = false, ...options }: RequestOptions & { skip?: boolean } = {},
): [FetchFn, FetchResult<TData>] {
  const request = useRequest();
  const [result, setResult] = useState<FetchResult<TData>>({ called: false, loading: !skip });

  const loading = () => {
    setResult(({ called }) => ({ called, loading: true }));
  };
  const done = (data: TData) => {
    setResult({ called: true, data, loading: false });
  };
  const failed = () => {
    setResult({ called: true, loading: false });
  };
  const fetch = async () => {
    try {
      loading();
      const data = await request<TData>(callType, options);
      done(data);
    } catch (e) {
      failed();
    }
  };
  useEffect(() => {
    if (!skip) fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.params, skip]);

  return [fetch, result];
}
